<template>
  <div class="demand-item-wrapper">
    <div class="content">
      <!-- 标题 -->
      <div class="title">
        <a-tooltip>
          <template slot="title" v-if="data.name && data.name.length >= 22">{{ data.name }}</template>
          <div class="title">
            <router-link :to="{ name: 'DemandDetail', params: { demandId: data.id } }">
              <span
                class="fund"
                :class="{active: cardContentHover}"
              >【￥{{ data['research_fund'] || '面议' }}】</span>
              <a-tag style="height: 18px;line-height: 18px;" v-if="isRecentDemand" color="purple">新</a-tag>
              <span :class="{active: cardContentHover}">{{ data.name && data.name.trim() }}</span>
            </router-link>
          </div>
        </a-tooltip>
      </div>

      <!-- 标签 -->
      <div class="tags">
        <CardTag class="tag" v-for="(item, index) in tags" :key="index" :content="item"></CardTag>
      </div>

      <!-- Hover切换部分 -->
      <div
        class="switch-content"
        @mouseover="cardContentHover = true"
        @mouseleave="cardContentHover = false"
      >
        <div v-if="cardContentHover">
          <transition name="fade">
            <div class="description">
              <p>{{ data.shortDescription || '暂无需求简介' }}</p>
            </div>
          </transition>
        </div>
        <div v-else class="info">
          <!-- <div class="item">
            <div class="label">研发经费：</div>
            <div class="text">{{ data['research_fund'] || '未知' }}</div>
          </div>-->
          <div class="item">
            <div class="label">研发类型：</div>
            <div class="text">{{ data.promotingDirection || '未知' }}</div>
          </div>

          <div class="item">
            <div class="label">截止时间：</div>
            <div
              class="text"
              v-if="data.expiredAt"
            >{{ data.expiredAt | moment('YYYY-MM-DD') }}</div>
          </div>
        </div>
      </div>
      <!-- 时间 -->
      <div class="publish">
        <a-row v-if="location" type="flex" justify="end" align="bottom">
          <a-col class="left" :span="12">
            <div class="label">所在地：</div>
            <div class="text">{{ location }}</div>
          </a-col>
          <a-col class="right" :span="12">{{ data.createdAt | moment('YYYY-MM-DD') }} 发布</a-col>
        </a-row>
        <a-row v-else type="flex" justify="end" align="bottom">
          <a-col
            class="right"
            :span="12"
            :offset="12"
          >{{ data.createdAt | moment('YYYY-MM-DD') }} 发布</a-col>
        </a-row>
      </div>
    </div>
    <!-- footer -->
    <div class="footer">
      <a-row class="list" type="flex" justify="center" align="middle">
        <a-col :span="8" class="item">
          <a-tooltip>
            <template slot="title">热度值：{{ data.viewedCount }}</template>

            <a-icon type="eye" />
            {{ data.viewedCount }}
          </a-tooltip>
        </a-col>
        <a-col :span="8" class="item">
          <a-tooltip>
            <template slot="title">关联项目数：{{ data.relatedProjectsCount }}</template>

            <a-icon type="fork" />
            {{ data.relatedProjectsCount }}
          </a-tooltip>
        </a-col>
        <a-col :span="8" class="item">
          <a-tooltip>
            <template slot="title">收藏数：{{ data.favoritedCount }}</template>

            <a-icon type="star" />
            {{ data.favoritedCount }}
          </a-tooltip>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import CardTag from '@/components/tools/CardTag'

export default {
  name: 'DemandItem',
  components: {
    CardTag
  },
  props: {
    data: {
      type: Object,
      require: true,
      default: () => ({})
    }
  },
  data () {
    return {
      cardContentHover: false
    }
  },
  computed: {
    isRecentDemand () {
      const createdAt = moment(this.data.verifiedAt)
      const now = moment()
      const daysDiff = now.diff(createdAt, 'days')
      // 近7天发布的为新需求
      return daysDiff <= 7
    },
    location () {
      const { location = [] } = this.data
      if (location && location.filter(item => item).length) {
        return location[0]
      }
      return ''
    },
    tags () {
      const arr = []
      arr.push(...this.data.areas)
      return arr
    }
  }
}
</script>

<style scoped lang="sass">

.demand-item-wrapper
  $back-white: #fff
  $fund-color: #f7b52d
  $active-color: #f4282d
  background-color: $back-white
  transition: box-shadow 0.25s ease-in
  border-radius: 2px
  &:hover
    box-shadow: -2px 8px 22px 0 rgba(0, 0, 0, 0.15)
    background-color: $back-white
  .content
    height: 210px
    padding: 20px 20px 12px
    position: relative
    font-size: 18px
    .title
      max-height: 44px
      overflow: hidden
      margin-bottom: 6px
      a
        display: block
        font:
          size: 18px
          weight: 700
        color: #333
        line-height: 22px

      .fund
        color: $fund-color
        margin-left: -10px

      .active
        color: $active-color

    .tags
      margin: 0
      padding: 0
      height: 18px
      line-height: 18px
      overflow: hidden
      .tag
        &:not(:last-child)
          margin-right: 4px

    .switch-content
      padding: 14px 0
      position: relative
      .info
        color: #666
        .item
          font-size: 16px
          line-height: 20px
          .label
            display: inline
            margin-right: 4px
          .text
            display: inline
            text-align: left
          &:not(:last-child)
            margin-bottom: 5px

      .description
        height: 66px
        color: #666
        overflow: hidden

        p
          font:
            size: 16px
            weight: 500
          line-height: 22px
          overflow-wrap: break-word
          word-break: break-all

    .publish
      color: #999
      font-size: 12px
      line-height: 18px
      position: absolute
      bottom: 12px
      width: 90%
      .left
        text-align: left
        .label
          display: inline
          margin-right: 2px
        .text
          display: inline
          text-align: left
      .right
        text-align: right

  .footer
    padding: 5px
    background-color: #fafafa
    border-top: 1px solid rgba(102, 102, 102, 0.15)
    border-radius: 0 0 2px 2px
    .list
      text-align: center
      .item
        &:not(:last-child)
          border-right: 1px solid rgba(0, 0, 0, 0.15)
</style>
